<template>
    <v-card>
        <v-card-title/>
        <v-flex style="overflow: auto">
            <v-data-table
                :headers="headers"
                :items="analyticsDataTable"
                :items-per-page="10"
                :footer-props="{
          'items-per-page-options': [5, 10, 20]
        }"
                :item-key="analyticsDataTable.id"
                :options.sync="options"
                :loading="loading"
                loading-text="Loading stations"
                :page="tableOptions && tableOptions.page ? tableOptions.page : 1"
                :server-items-length="probesCount"
                class="elevation-1 data-analysis-table"
            >
                <template v-slot:item="{ item }">
                    <tr
                        :key="`da_row_${item.id}`"
                    >
                        <td class="text-center">{{ item.id ? item.id : '-' }}</td>
                        <td class="text-center">{{ item.created_at ? item.created_at : '-' }}</td>
                        <td class="custom-column-width text-center">{{
                                item.filters.company && item.filters.company.length > 0 ? getFilterData('companies', item.filters.company, 'value', 'id') : '-'
                            }}
                        </td>
                        <td class="custom-column-width text-center">
                            {{
                                item.filters.region && item.filters.region.length > 0 ? item.filters.region.join(', ') : '-'
                            }}
                        </td>
                        <td class="text-center">{{
                                item.filters.season && item.filters.season.length > 0 ? getFilterData('seasons', item.filters.season, 'title', 'id') : (item.filters.dateBetween && item.filters.dateBetween.length > 0 ? item.filters.dateBetween.join(' - ') : '-')
                            }}
                        </td>
                        <td class="custom-column-width text-center">{{
                                item.filters.culture && item.filters.culture.length > 0 ? getFilterData('cultures', item.filters.culture, 'value', 'culture_id') : '-'
                            }}
                        </td>
                        <td class="text-center"
                            :title="item.probes && item.probes.length > 0 ? item.probes.join(', ') : ''">
                            {{
                                item.probes && item.probes.length > 0 ? `${item.probes[0]} ${item.probes.length > 1 ? '(+' + (item.probes.length - 1) + ' others)' : ''}` : ''
                            }}
                        </td>
                        <td class="text-center">
                            <v-chip
                                :color="item.status === 'finished' ? 'success' : item.status === 'error' ? 'error' : 'grey lighten-2'">
                                {{ item.status | cleanString }}
                            </v-chip>
                        </td>
                        <td class="text-center">
                            <v-icon v-if="item.probeCsvFileId" color="green" small>mdi-check</v-icon>
                            <v-icon v-else color="red" small>mdi-close</v-icon>
                        </td>
                        <td class="text-center">
                            {{ item.file_type }}
                        </td>
                        <td class="text-center">
                            <v-icon v-if="item.status === 'finished'" @click="handleDownloadCsvFile(item)">
                                mdi-download
                            </v-icon>
                            <v-icon v-else @click="handleRefresh()">
                                mdi-refresh
                            </v-icon>
                        </td>
                    </tr>

                </template>
            </v-data-table>
        </v-flex>
    </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'DataAnalyticsListTable',
    data() {
        return {
            options: {},
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'Created at',
                    align: 'center',
                    sortable: false,
                    value: 'created_at',
                },
                {
                    text: 'Companies',
                    align: 'center',
                    class: 'test',
                    sortable: false,
                    value: 'filter_companies',
                },
                {
                    text: 'Regions',
                    align: 'center',
                    sortable: false,
                    value: 'filter_regions',
                },
                {
                    text: 'Seasons/Dates',
                    align: 'center',
                    sortable: false,
                    value: 'filter_seasons',
                },
                {
                    text: 'Cultures',
                    align: 'center',
                    sortable: false,
                    value: 'filter_cultures',
                },
                {
                    text: 'Probes',
                    align: 'center',
                    sortable: false,
                    value: 'probes',
                },
                {
                    text: 'Status',
                    align: 'center',
                    sortable: false,
                    value: 'status',
                },
                {
                    text: 'Average statistics',
                    align: 'center',
                    sortable: false,
                    value: 'probeCsvFileId',
                },
                {
                    text: 'File type',
                    align: 'center',
                    sortable: false,
                    value: 'file_type',
                },
                {
                    text: 'Download',
                    align: 'center',
                    sortable: false,
                    value: 'download',
                },
            ],
        };
    },
    computed: {
        ...mapState('analytics', ['loading', 'probesCount', 'tableOptions', 'analyticsDataProbeList', 'analyticsTableOptions', 'analyticsDataTable', 'selectedProbes', 'allDropdownItems']),
    },
    watch: {
        options(val) {
            this.setTableOptions(val);
        },
    },
    methods: {
        ...mapActions('analytics', ['downloadCsvFile', 'getAnalyticsDataTableData']),
        ...mapMutations('analytics', ['setTableOptions']),
        async handleDownloadCsvFile(item) {
            const response = await this.downloadCsvFile(item.id);
            if (!response) {
                return;
            }
            const url = window.URL.createObjectURL(new Blob([response]));

            const link = document.createElement('a');
            link.href = url;
            let name = '';

            if (item.csv_type) {
                name = `${item.csv_type}_`;
            }

            let file_extension = '.csv';

            if (item?.file_type === 'xlsx') {
                file_extension = '.xlsx';
            }

            name += `${item.id}${file_extension}`;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        async handleRefresh() {
            await this.getAnalyticsDataTableData();
        },
        getFilterData(relatedType, relatedArray, mapProps, filterProps) {
            return this.allDropdownItems[relatedType]
                .filter(item => relatedArray.includes(item[filterProps]))
                .map(item => item[mapProps])
                .join(', ');
        },
    },
};
</script>

<style scoped>
.data-analysis-table {
    width: 100%;
    overflow-y: auto;
    min-width: auto;
}

::v-deep .custom-column-width {
    max-width: 300px !important;
    word-break: break-word;
}
</style>